"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInfoAsync = void 0;
const initWorker_js_1 = require("./initWorker.js");
const parseTokens_js_1 = require("./parseTokens.js");
const userInfoAsync = (oidc) => __awaiter(void 0, void 0, void 0, function* () {
    if (oidc.userInfo != null) {
        return oidc.userInfo;
    }
    // We wait the synchronisation before making a request
    while (oidc.tokens && !(0, parseTokens_js_1.isTokensValid)(oidc.tokens)) {
        yield (0, initWorker_js_1.sleepAsync)(200);
    }
    if (!oidc.tokens) {
        return null;
    }
    const accessToken = oidc.tokens.accessToken;
    if (!accessToken) {
        return null;
    }
    const oidcServerConfiguration = yield oidc.initAsync(oidc.configuration.authority, oidc.configuration.authority_configuration);
    const url = oidcServerConfiguration.userInfoEndpoint;
    const fetchUserInfo = (accessToken) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield fetch(url, {
            headers: {
                authorization: `Bearer ${accessToken}`,
            },
        });
        if (res.status !== 200) {
            return null;
        }
        return res.json();
    });
    const userInfo = yield fetchUserInfo(accessToken);
    oidc.userInfo = userInfo;
    return userInfo;
});
exports.userInfoAsync = userInfoAsync;
//# sourceMappingURL=user.js.map